import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Attribute} from '../../../_models/attribute.model';

@Component({
  selector: 'app-select-multiple',
  templateUrl: './select-multiple.component.html',
  styleUrls: ['./select-multiple.component.scss']
})
export class SelectMultipleComponent implements OnInit {

  @Input() items: Attribute[];
  @Input() defaultItemList: Attribute[];
  @Output() selectedItemList = new EventEmitter<Attribute[]>();

  constructor() {
  }

  ngOnInit() {
  }

  tapped(item: Attribute) {
    const i = this.defaultItemList.indexOf(item);
    if (i >= 0) {
      this.defaultItemList.splice(i, 1);
    } else {
      this.defaultItemList.push(item);
    }
    this.selectedItemList.emit(this.defaultItemList);
  }

  checkChecked(item: Attribute): boolean {
    return this.defaultItemList.indexOf(item) >= 0;
  }

  buttonName(items: Attribute[]): string {
    if (!items || items.length === 0) {
      return '';
    }
    if (items.length === this.items.length) {
      return 'All';
    }
    const nameList = [];
    for (const item of items) {
      nameList.push(item.name);
    }
    let name = nameList.join();
    if (name.length > 49) {
      name = name.slice(0, 49) + '...';
    }
    return name;
  }
}
